import { useState, useEffect, useRef } from "react";
import { ArrowUpCircleIcon } from "@heroicons/react/24/solid";

const MassUploadDropdown = ({
  options = [],
  defaultValue = "",
  onChangeFunction,
  className = "",
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleSelect = (itemSelected) => {
    setIsOpen(false);
    onChangeFunction({ target: { value: itemSelected.value } });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={dropdownRef}
      className={`relative inline-block group ${disabled ? "cursor-not-allowed opacity-50" : "hover:bg-hquaternary"
        } rounded-full transition-colors duration-300`}
    >
      <button
        onClick={() => setIsOpen((prev) => !prev)}
        className={`px-3 py-1 flex items-center justify-around gap-2 text-xs font-medium rounded-full border border-quaternary bg-transparent appearance-none transition-colors duration-300 shadow-md
          ${disabled
            ? "text-quaternary border-quaternary bg-transparent"
            : "text-quaternary group-hover:text-white group-hover:bg-transparent cursor-pointer"
          }
          focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-quaternary focus:ring-opacity-70 ${className}`}
      >
        <ArrowUpCircleIcon
          className={`h-4 w-4 pointer-events-none transition-colors duration-300 ${disabled
            ? "text-quaternary"
            : "text-quaternary group-hover:text-white"
            }`}
        />

        <span>Mass Upload</span>
      </button>

      {isOpen && (
        <div className="absolute z-50 mt-2 overflow-hidden rounded-[10px] w-full bg-white font-medium text-center text-xs border border-gray-200 border-[1px] rounded shadow">
          {options.map((option) => (
            <div
              key={option}
              value={option.value}
              onClick={() => handleSelect(option)}
              className="px-4 py-2 hover:bg-hquaternary hover:text-white cursor-pointer text-quaternary border-b border-b-[1px] border-gray-200"
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MassUploadDropdown;
